export default "__VITE_ASSET__BEGrZzHc__"